import classNames from 'classnames/bind';
import React, { useMemo } from 'react';
import { NoDataDash } from '../../../../../components/formatters';
import useFetchCompanyDocsTypes from '../../../../../hooks/documents/useFetchFilingsTypes';
import { CompanyFilingsDto } from '../../../../../services/dtos/companyFilings/companyFilings.dto';
import { GroupedTableRowRendererProps } from '../../GroupedTableRow/GroupedTableRow.types';

const CompanyFilingsTypeRenderer = ({
  data,
  columnConfig,
  row: { isDisabled, isHovered },
}: GroupedTableRowRendererProps<CompanyFilingsDto>): React.ReactElement | null => {
  const { data: types } = useFetchCompanyDocsTypes();

  const typesObject = useMemo(
    () =>
      types?.reduce(
        (acc: Record<number, string>, item) => ({
          ...acc,
          [item.id]: item.name,
        }),
        {}
      ) || {},
    [types]
  );

  return (
    <div className={classNames({ 'gray-out': isDisabled && isHovered })}>
      {typesObject[data[columnConfig.dataKey]] ? (
        <span>{typesObject[data[columnConfig.dataKey]]}</span>
      ) : (
        <NoDataDash />
      )}
    </div>
  );
};

export default CompanyFilingsTypeRenderer;
